import React, { useState, useEffect, memo } from 'react'
import moment from 'moment'
import StatisticsTable from '../../../../../Components/Campaigns/Page/Conversions/StatisticsTable'

import { useConversionReportsRequest } from '../hook/useConversionReportsRequest'

const ConversionStatistics = ({ campaignId }) => {
  const [data, setData] = useState([])
  const [headers, setHeaders] = useState([])
  const { getConversionsStatistics } = useConversionReportsRequest(campaignId)

  const fecthData = async () => {
    const {
      totalUploads,
      totalFlyerCodesCount,
      totalConversionsCount,
      metricsInfo,
      firstConversionDate,
      lastConversionDate,
    } = await getConversionsStatistics()

    setHeaders([
      'Total Uploads',
      'Flyer Codes',
      'Conversions',
      ...metricsInfo.map(({ metricName }) => metricName),
      'First Conversion',
      'Last Conversion',
    ])
    setData([
      [
        totalUploads,
        totalFlyerCodesCount,
        totalConversionsCount,
        ...metricsInfo.map(({ conversionsCount }) => conversionsCount),
        firstConversionDate
          ? moment(firstConversionDate).format('DD MMM YYYY, HH:mm')
          : '-',
        lastConversionDate
          ? moment(lastConversionDate).format('DD MMM YYYY, HH:mm')
          : '-',
      ],
    ])
  }

  useEffect(() => {
    fecthData()
  }, [])

  return <StatisticsTable headers={headers} data={data} />
}

export default memo(ConversionStatistics)
